import classNames from "classnames";
import React from "react";

function StepItem({item, isActive}) {
    return (<li className={classNames("steps-segment", {
        "is-active": isActive || false
    })}>
        <span className="steps-marker">{item.marker}</span>
        <div className="steps-content">
            <p className="is-size-4">{item.content}</p>
        </div>
    </li>);
}

export function StepList({items, activeItem}) {

    return (<ul className="steps is-balanced has-content-above has-content-centered">
        {items.map((item, index) => <StepItem
            key={item.name}
            item={item}
            isActive={activeItem ? (activeItem === item.name) : (index === 0)}
        />)}
    </ul>);
}